<script>
import store from '@shared/store'
import axios from '@shared/module/axios'
import applicationLanguage from '@shared/module/applicationLanguage'

const getPayloadForReturningCustomer = () => {
  const application = store.getApplication()
  return {
    loan: application.loan,
    notPep: application.notPep
  }
}

export default {
    methods: {
        submitAsNewCustomer() {
          return axios.post('/api/applications/submit', { ...store.getApplication(), locale: applicationLanguage() })
               .then(this.clearApplication)
        },
        submitAsReturningCustomer() {
          const customerPin = store.state.currentUser.pin
          const application = store.getApplication()
          return axios.post(`/api/customers/${customerPin}/applications`, {
            ...getPayloadForReturningCustomer(),
            creditRegistryConsent: application.creditRegistryConsent,
            dataProcessingConsent: application.dataProcessingConsent
          })
            .then(this.clearApplication)
        },
        submitComfortLoan() {
          const customerPin = store.state.currentUser.pin
          return axios.post(`/api/customers/${customerPin}/comfort`, getPayloadForReturningCustomer())
                .then(this.clearApplication)
        },
        confirmRegularLoanApplication() {
          const draft = store.getDraft()
          const reference = draft.loan.reference
          const parameters = {
            amount: draft.loan.amount,
            periodInMonths: draft.loan.periodInMonths,
            productId: reference,
            marketingConsent: draft.marketingConsent,
            notPep: draft.notPep
          }
          return axios.post(`/api/applications/${reference}/confirm`, parameters)
        },
        clearApplication() {
          store.clearSelectedProduct()
          store.clearApplication()
          store.clearDraft()
        }
    }
}
</script>
